import { Helmet } from "react-helmet";
import { FC } from "react";

import CommonLayout from "../../AccountPage/CommonLayout";
import ClientReservation from "../ClientReservation";
import ReservationSearchDetail from "./ReservationSearchDetail";

export interface AccountPageProps {
  className?: string;
}

const ReservationSearchResult: FC<AccountPageProps> = ({ className = "" }) => {
  return (
    <CommonLayout>
      <div
        className={`overflow-hidden relative nc-ListingFlightsPage ${className}`}
        data-nc-id="ListingFlightsPage"
      >
        <Helmet>
          <title>
            EventToBee | Location d'espaces : salles, lofts, jardins & boutiques – Paris & Île-de-France
          </title>
        </Helmet>

        <div className="">
          <ReservationSearchDetail className="pb-24 lg:b-28" />
        </div>
      </div>
    </CommonLayout>
  );
};

export default ReservationSearchResult;
